import React from 'react';
import { motion } from 'framer-motion';
export const TrustSection = () => {
  const brands = ['Psychology Today', 'Wired', 'TechCrunch', 'The Verge', 'Vice'];
  return <section className="py-12 border-y border-gray-900 bg-[#050505] relative overflow-hidden" data-id="element-2908" data-mp="2e8nnkw9lc66n">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-2909" data-mp="2j6p69g33u3hl">
        <p className="text-center text-gray-500 text-sm font-medium tracking-wide mb-8" data-id="element-2910" data-mp="2j9bdfem32gza">
          Trusted by thousands for relationship clarity
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-40 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-2911" data-mp="3axbr6nkk7qwj">
          {brands.map((brand, index) => <motion.div key={brand} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="text-lg md:text-xl font-bold text-gray-400 hover:text-white transition-colors" data-id="element-2912" data-mp="3251gl55r5jer" data-mpi={index}>
              {brand}
            </motion.div>)}
        </div>
      </div>
    </section>;
};